import fetch from 'isomorphic-fetch';
import isNil from 'lodash/isNil';
import merge from 'lodash/merge';
import appendQuery from 'append-query';
import ErrorMessage from './ServiceMessages';

export const filterNilValue = obj => (
  Object.prototype.toString.call(obj) !== '[object Object]' ? obj : Object.keys(obj).filter(key => !isNil(obj[key]))
    .reduce(((acc, key) => ({ ...acc, [key]: filterNilValue(obj[key]) })), {})
);

const getDefaultFetchConfig = () => ({
  credentials: 'include',
});

const getPayload = (resp, reject, responseType) => {
  let payload = resp;
  if (responseType === 'json') {
    try {
      payload = JSON.parse(resp || '{}');
    } catch (e) {
      reject(new ErrorMessage('unknown error'));
    }
  }
  return payload;
};

const getFormData = (object) => {
  return Object.keys(object).map(key => `${encodeURIComponent(key) }=${ encodeURIComponent(object[key])}`).join('&');
};

const service = (method, path, fetchConfig, responseType) => {
  let url = path;
  const options = merge(getDefaultFetchConfig(), { ...fetchConfig, method });
  if (method === 'get') {
    url = appendQuery(path, { ...(options.body || {}), _: new Date().getTime() });
    // FireFox ajax get request can not have a body, so let it be `undefined`
    options.body = undefined;
  } else {
    const isFormUrlencoded = options.headers && options.headers['Content-Type']
    && options.headers['Content-Type'].indexOf('x-www-form-urlencoded') !== -1;
    // Filter null and undfindfind field.
    options.body = isFormUrlencoded
      ? getFormData(filterNilValue(options.body || {}))
      : JSON.stringify(filterNilValue(options.body || {}));
  }

  return new Promise((resolve, reject) => {
    fetch(url, options).then(
      (response) => {
        const { status, ok } = response;
        response.text().then((resp) => {
          const payload = getPayload(resp, reject, responseType);
          ok ? resolve({ payload, response })
            : reject(new ErrorMessage(payload, status));
        });
      },
      ({ message }) => {
        reject(new ErrorMessage(message));
      },
    );
  });
};

export default [ 'get', 'post', 'put' ].reduce(
  (api, method) => ({ ...api, [method]: service.bind(null, method) }), {},
);
